import React, { useState } from "react";
import { Table, Box} from "@cloudscape-design/components";
import { SharedDeploymentsTableProps } from "../../types/deploymentTypes";
import TablePreferences from "components/Layout/TablePreferences";
import { PreferencesType } from "types/types";

const pageSizeOptions = [
  { value: 10, label: "10 rows" },
  { value: 20, label: "20 rows" },
  { value: 50, label: "50 rows" },
  { value: 100, label: "100 rows" },
];

export const DeploymentsTable: React.FC<SharedDeploymentsTableProps> = ({
  columnDefinitions,
  deploymentType,
  columnDisplayOrder,
  deploymentsList,
  isLoadingDeployments,
  loadingDeploymentsError
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  const STORAGE_KEY = `${deploymentType}-table-preferences`

  const DEFAULT_TABLE_PREFERENCES = {
    pageSize: 10,
    wrapLines: false,
    stripedRows: true,
    contentDensity: "comfortable",
    contentDisplay: columnDisplayOrder.map((col) => ({
      id: col.id,
      visible: col.visible,
      disabled: col.alwaysVisible,
    })),
    stickyColumns: { first: 0, last: 0 },
  }

  const [preferences, setPreferences] = useState<PreferencesType>(()=>{
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : DEFAULT_TABLE_PREFERENCES
  });

  const handlePreferencesChange = (detail: any) => {
    setPreferences(detail);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(detail));
  };

  return (
    <>
      <Table
        columnDefinitions={columnDefinitions}
        items={deploymentsList}
        columnDisplay={preferences.contentDisplay}
        stickyColumns={preferences.stickyColumns}
        wrapLines={preferences.wrapLines}
        contentDensity={
          preferences.contentDensity === "compact" ? "compact" : "comfortable"
        }
        loading={isLoadingDeployments}
        loadingText={
          deploymentType === "shared"
            ? "Loading shared deployments"
            : "Loading dedicated deployments"
        }
        empty={
          <Box textAlign="center" color="inherit">
            {loadingDeploymentsError ? (
              <>
                <b>Error</b>
                <Box padding={{ bottom: "s" }} variant="p">
                  {loadingDeploymentsError}
                </Box>
              </>
            ) : (
              <>
                <b>No deployments</b>
                <Box padding={{ bottom: "s" }} variant="p">
                  No deployments to display please create one.
                </Box>
              </>
            )}
          </Box>
        }
        stripedRows
        stickyHeader

        preferences={
          <TablePreferences
            preferences={preferences}
            setPreferences={handlePreferencesChange}
            setCurrentPage={setCurrentPage}
            columnOptions={columnDisplayOrder}
            pageSizeOptions={pageSizeOptions}
          />
        }
      />
      
    </>
  );
};
        